import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import { useAuth0 } from "@auth0/auth0-react";

export default function Home() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, user } = useAuth0();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated && user) {
        // Check if user is SUPER_ADMIN
        const internalRole = user["https://api.storemandu.com/internal"];
        
        if (internalRole === "SUPER_ADMIN") {
          navigate(`/admin`);
        } else {
          // Check if user has a default store ID
          const defaultStoreId = user["https://api.storemandu.com/defaultStoreId"];
          
          if (defaultStoreId) {
            navigate(`/store/${defaultStoreId}`);
          } else {
            // Fallback to admin if no default store
            navigate(`/login`);
          }
        }
      } else {
        navigate(`/login`);
      }
    }
  }, [isAuthenticated, isLoading, user, navigate]);

  return (
    <>
      <Helmet>
        <title>Storemandu</title>
        <meta name="description" content="Storemandu Descriptions" />
        <meta
          name="og:title"
          property="og:title"
          content="The Storemandu Content"
        />
        <meta
          name="og:description"
          property="og:description"
          content="The Storemandu meta Description Content"
        />
        <meta name="og:url" property="og:url" content="" />
        <meta name="og:image" property="og:image" content="" />
        <meta name="robots" content="" />
      </Helmet>
      <div className="flex items-center justify-center h-screen bg-background">
        {/* <img src={logo} alt="Storemandu" className="h-[20%] " /> */}
      </div>
    </>
  );
}
